<template>
  <!-- 部门管理 -->
  <div class="edu_pages">
    <!-- 暂无权限 -->
    <the-no-authority v-if="!authority"></the-no-authority>

    <template v-if="authority">
      <div class="edu_pages_content_box">
        <div class="edu_page_title_box">
          <div class="title_box">
            <div class="color_lump_box"></div>
            <span>部门管理</span>
          </div>
          <div class="edu_operation_box">
            <div class="add_icon_box button-box" @click="openAddBox()">
              <div></div>
              <span>新增</span>
            </div>
          </div>
        </div>
        <div class="edu_pages_content_body_box">
          <div class="edu_table_box">
            <el-table
              :data="dataList.list"
              height="100%"
              border
              :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
              class="table_box"
            >
              <el-table-column label="序号" width="70" align="center">
                <template slot-scope="scope">
                  {{
                    listRequestData.pageSize * (listRequestData.pageNum - 1) +
                      scope.$index +
                      1
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="departmentName"
                label="部门名称"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="addTime"
                label="添加时间"
                width="250"
                align="center"
              >
                <template slot-scope="rowData">
                  {{ $Common.dateFormatDateTwo(rowData.row.addTime) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="rowData">
                  <el-link
                    type="primary"
                    @click="getDataOne(rowData.row)"
                    :underline="false"
                    >编辑</el-link
                  >
                  <el-divider direction="vertical"></el-divider>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="delData(rowData.row.departmentId)"
                          :underline="false"
                          >删除</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="departmentUser(rowData.row.departmentId)"
                          :underline="false"
                          >部门成员</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="userAddClick(rowData.row.departmentId)"
                          :underline="false"
                          >成员新增</el-link
                        ></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edu_pagination_box">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              :current-page="dataList.pageNum"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="listRequestData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="dataList.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </template>
    <el-dialog
      :title="type == 'add' ? '添加部门信息' : '编辑部门信息'"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      :before-close="handleClose"
      :visible.sync="showDialog"
    >
      <div class="dialog_box">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="fromInfo"
          label-width="0px"
        >
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>部门名称:</span>
              <el-form-item prop="departmentName">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="fromInfo.departmentName"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog_save_cancel_box">
          <div class="cancel_item_box" @click="handleClose">取消</div>
          <div
            class="save_item_box"
            @click="dataValidate('ruleForm')"
            v-if="type == 'add'"
          >
            提交
          </div>
          <div
            class="save_item_box"
            @click="dataValidate('ruleForm')"
            v-if="type == 'edit'"
          >
            确定修改
          </div>
        </div>
      </div>
    </el-dialog>
    <department-table-dialog
      :showDialog="dShowDialog"
      :departmentId="departmentId"
      @close="dClose"
    ></department-table-dialog>
    <department-user-add-dialog
      :showDialog="uShowDialog"
      :departmentId="departmentId"
      @close="uClose"
    ></department-user-add-dialog>
  </div>
</template>

<script>
import theNoAuthority from "@/components/theNoAuthority.vue";
import DepartmentTableDialog from "./components/DepartmentTableDialog.vue";
import DepartmentUserAddDialog from "./components/DepartmentUserAddDialog.vue";
export default {
  name: "",
  components: {
    theNoAuthority,
    DepartmentTableDialog,
    DepartmentUserAddDialog
  },
  props: {},
  data() {
    return {
      // 有无权限
      authority: true,
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      type: "add",
      fromInfo: {
        eduId: this.$store.getters.getEduData.eduId,
        departmentName: "",
        departmentId: "",
        departmentLevel: ""
      },
      showDialog: false,
      dShowDialog: false,
      departmentId: "",
      uShowDialog: false,
      rules: {
        departmentName: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    clearInfo() {
      this.fromInfo = {
        eduId: this.$store.getters.getEduData.eduId,
        departmentName: "",
        departmentId: "",
        departmentLevel: ""
      };
    },
    openAddBox() {
      this.type = "add";
      this.showDialog = true;
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.showDialog = false;
      this.clearInfo();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      this.getDataList();
    },
    getDataOne(dataInfo) {
      this.type = "edit";
      this.fromInfo.departmentName = dataInfo.departmentName;
      this.fromInfo.departmentId = dataInfo.departmentId;
      this.fromInfo.departmentLevel = dataInfo.departmentLevel;
      this.showDialog = true;
    },
    async getDataList() {
      let res = await this.$Http.getEduDepartmentList(
        this.listRequestData,
        true
      );
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.totalSize;
        this.dataList.pages = res.data.totalPages;
        this.dataList.list = res.data.content;
      } else if (res.code == 101) {
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    dataValidate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            this.addDataInfo();
          } else {
            this.editDataInfo();
          }
        } else {
          return false;
        }
      });
    },
    async addDataInfo() {
      delete this.fromInfo.departmentId;
      let res = await this.$Http.addEduDepartmentList(this.fromInfo, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.handleClose();
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async editDataInfo() {
      delete this.fromInfo.eduId;
      delete this.fromInfo.departmentLevel;
      let res = await this.$Http.editEduDepartmentList(this.fromInfo, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.handleClose();
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = JSON.parse(JSON.stringify([dataId]));
          let res = await this.$Http.delDepartment(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    departmentUser(id) {
      this.departmentId = id;
      this.dShowDialog = true;
    },
    dClose() {
      this.dShowDialog = false;
    },
    userAddClick(id) {
      this.departmentId = id;
      this.uShowDialog = true;
    },
    uClose() {
      this.uShowDialog = false;
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
